import styled, { css } from 'styled-components/native';

import { Text as TextRaw } from 'app/components/Common/Styled';

export const Text = styled(TextRaw)<{ isDisabled?: boolean }>`
  ${({ isDisabled, theme }) => css`
    color: ${theme.colors[isDisabled ? 'default' : 'bodyText']};
  `}
`;
